<template>
  <span>
    <!--Bosque de encino-->
    <DaiCapaGeojson
      id="vegetacion_bosque_encino"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_bosque-de-encino.geojson'"
      titulo="Bosque de encino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#23AA62' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_encino']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_bosque_encino_arborea"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-arborea-de-bosque-de-encino.geojson'"
      titulo="Vegetación secundaria arbórea de bosque de encino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#60B143' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_encino_arborea']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_bosque_encino_arbustiva"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-arbustiva-de-bosque-de-encino.geojson'"
      titulo="Vegetación secundaria arbustiva de bosque de encino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#92B522' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_encino_arbustiva']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_bosque_encino_herbacea"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-herbacea-de-bosque-de-encino.geojson'"
      titulo="Vegetación secundaria herbacea de bosque de encino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#C5B314' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_encino_herbacea']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />

    <!--Bosque de encino-pino-->
    <DaiCapaGeojson
      id="vegetacion_bosque_encino_pino"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_bosque-de-encino-pino.geojson'"
      titulo="Bosque de encino-pino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#2A90A4' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_encino_pino']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_bosque_encino_pino_arbustiva"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-arbustiva-de-bosque-de-encino-pino.geojson'"
      titulo="Vegetación secundaria arbustiva de bosque de encino-pino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#26A080' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_encino_pino_arbustiva']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />

    <!--Bosque de oyamel-->
    <DaiCapaGeojson
      id="vegetacion_bosque_oyamel"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_bosque-de-oyamel.geojson'"
      titulo="Bosque de oyamel"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#e3cc57' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_oyamel']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_bosque_oyamel_arbustiva"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-arbustiva-de-bosque-de-oyamel.geojson'"
      titulo="Vegetación secundaria arbustiva de bosque de oyamel"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#fbd88a' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_oyamel_arbustiva']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />

    <!--Bosque de pino-->
    <DaiCapaGeojson
      id="vegetacion_bosque_pino"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_bosque-de-pino.geojson'"
      titulo="Bosque de pino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#262516' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_pino']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_bosque_pino_arborea"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-arborea-de-bosque-de-pino.geojson'"
      titulo="Vegetación secundaria arbórea de bosque de pino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#545220' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_pino_arborea']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_bosque_pino_arbustiva"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-arbustiva-de-bosque-de-pino.geojson'"
      titulo="Vegetación secundaria arbustiva de bosque de pino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#868360' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_pino_arbustiva']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    
    <!--Bosque de pino-encino-->
    <DaiCapaGeojson
      id="vegetacion_bosque_pino_encino"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_bosque-de-pino-encino.geojson'"
      titulo="Bosque de pino-encino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#de2d16' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_pino_encino']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_bosque_pino_encino_arborea"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-arborea-de-bosque-de-pino-encino.geojson'"
      titulo="Vegetación secundaria arbórea de bosque de pino-encino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#ef7913' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_pino_encino_arborea']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_bosque_pino_encino_arbustiva"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-arbustiva-de-bosque-de-pino-encino.geojson'"
      titulo="Vegetación secundaria arbustiva de bosque de pino-encino"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#f9b434' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_pino_encino_arbustiva']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />

    <!--Bosque de táscate-->
    <DaiCapaGeojson
      id="vegetacion_bosque_tascate"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_bosque-de-tascate.geojson'"
      titulo="Bosque de táscate"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#79607d' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_tascate']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_bosque_tascate_arborea"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-arborea-de-bosque-de-tascate.geojson'"
      titulo="Vegetación secundaria arbórea de bosque de táscate"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#b78ebc' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_tascate_arborea']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_bosque_tascate_arbustiva"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-arbustiva-de-bosque-de-tascate.geojson'"
      titulo="Vegetación secundaria arbustiva de bosque de táscate"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#dccddd' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_tascate_arbustiva']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />

    <!--Matorrales-->
    <DaiCapaGeojson
      id="vegetacion_matorral_crasicaule"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_matorral-crasicaule.geojson'"
      titulo="Matorral crasicaule"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#ecac69' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_matorral_crasicaule']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_matorral_crasicaule_arbustiva"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-secundaria-arbustiva-de-matorral-crasicaule.geojson'"
      titulo="Vegetación secundaria arbustiva de matorral crasicaule"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#9b6936' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_matorral_crasicaule_arbustiva']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_matorral_desertico_rosetofilo"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_matorral-desertico-rosetofilo.geojson'"
      titulo="Matorral desértico rosetófilo"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#542816' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_matorral_desertico_rosetofilo']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />

    <!--Pastizales-->
    <DaiCapaGeojson
      id="vegetacion_pastizal_cultivado"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_pastizal-cultivado.geojson'"
      titulo="Pastizal cultivado"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#ffa64a' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_pastizal_cultivado']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_pastizal_inducido"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_pastizal-inducido.geojson'"
      titulo="Pastizal inducido"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#ff7759' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_pastizal_inducido']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_pastizal_halofilo"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_pastizal-halofilo.geojson'"
      titulo="Pastizal halófilo"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#ff4373' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_pastizal_halofilo']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />

    <!--Otra-->
    <DaiCapaGeojson
      id="vegetacion_bosque_cultivado"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_bosque-cultivado.geojson'"
      titulo="Bosque cultivado"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#8f4a4e' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_bosque_cultivado']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_halofila_hidrofila"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_vegetacion-halofila-hidrofila.geojson'"
      titulo="Vegetación halófila hidrófila"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#528d92' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_halofila_hidrofila']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_pradera_alta_montana"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_pradera-de-alta-montana.geojson'"
      titulo="Pradera alta montaña"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#947a16' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_pradera_alta_montana']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_tular"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_tular.geojson'"
      titulo="Tular"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#269cb5' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_tular']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_sin_vegetacion_aparente"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_sin-vegetacion-aparente.geojson'"
      titulo="Sin vegetación aparente"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#dadada' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_sin_vegetacion_aparente']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="vegetacion_desprovisto_vegetacion"
      :url="publicPath+'data/capasv2/07_vegetacion_descripcion_desprovisto-de-vegetacion.geojson'"
      titulo="Desprovisto de vegetación"
      :estilo-capa="{
        stroke: { width: 1, color: 'white' },
        fill: { color: '#888' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles['vegetacion_desprovisto_vegetacion']"
      :contenidoTooltip="tooltip"
      :use-loader="true"
    />
  </span>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      visibles: {
        // Bosque de encino
        vegetacion_bosque_encino: false,
        vegetacion_bosque_encino_arborea: false,
        vegetacion_bosque_encino_arbustiva: false,
        vegetacion_bosque_encino_herbacea: false,
        // Bosque de encino-pino
        vegetacion_bosque_encino_pino: false,
        vegetacion_bosque_encino_pino_arbustiva: false,
        // Bosque de oyamel
        vegetacion_bosque_oyamel: false,
        vegetacion_bosque_oyamel_arbustiva: false,
        // Bosque de pino
        vegetacion_bosque_pino: false,
        vegetacion_bosque_pino_arborea: false,
        vegetacion_bosque_pino_arbustiva: false,
        // Bosque de pino-encino
        vegetacion_bosque_pino_encino: false,
        vegetacion_bosque_pino_encino_arborea: false,
        vegetacion_bosque_pino_encino_arbustiva: false,
        // Bosque de táscate
        vegetacion_bosque_tascate: false,
        vegetacion_bosque_tascate_arborea: false,
        vegetacion_bosque_tascate_arbustiva: false,
        // Matorrales
        vegetacion_matorral_crasicaule: false,
        vegetacion_matorral_crasicaule_arbustiva: false,
        vegetacion_matorral_desertico_rosetofilo: false,
        // Pastizales
        vegetacion_pastizal_cultivado: false,
        vegetacion_pastizal_inducido: false,
        vegetacion_pastizal_halofilo: false,
        // Otra
        vegetacion_bosque_cultivado: false,
        vegetacion_halofila_hidrofila: false,
        vegetacion_pradera_alta_montana: false,
        vegetacion_tular: false,
        vegetacion_sin_vegetacion_aparente: false,
        vegetacion_desprovisto_vegetacion: false,
      },
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    ...mapState("mapa", ["temasExpandidos"]),
    esteTemaActivo() {
      return this.temasExpandidos.vegetacion;
    },
  },
  watch: {
    esteTemaActivo(nv) {
      // Bosque de encino
      this.visibles.vegetacion_bosque_encino = nv;
      this.visibles.vegetacion_bosque_encino_arborea = nv;
      this.visibles.vegetacion_bosque_encino_arbustiva = nv;
      this.visibles.vegetacion_bosque_encino_herbacea = nv;
      // Bosque de encino-pino
      this.visibles.vegetacion_bosque_encino_pino = nv;
      this.visibles.vegetacion_bosque_encino_pino_arbustiva = nv;
      // Bosque de oyamel
      this.visibles.vegetacion_bosque_oyamel = nv;
      this.visibles.vegetacion_bosque_oyamel_arbustiva = nv;
      // Bosque de pino
      this.visibles.vegetacion_bosque_pino = nv;
      this.visibles.vegetacion_bosque_pino_arborea = nv;
      this.visibles.vegetacion_bosque_pino_arbustiva = nv;
      // Bosque de pino-encino
      this.visibles.vegetacion_bosque_pino_encino = nv;
      this.visibles.vegetacion_bosque_pino_encino_arborea = nv;
      this.visibles.vegetacion_bosque_pino_encino_arbustiva = nv;
      // Bosque de táscate
      this.visibles.vegetacion_bosque_tascate = nv;
      this.visibles.vegetacion_bosque_tascate_arborea = nv;
      this.visibles.vegetacion_bosque_tascate_arbustiva = nv;
      // Matorrales
      this.visibles.vegetacion_matorral_crasicaule = nv;
      this.visibles.vegetacion_matorral_crasicaule_arbustiva = nv;
      this.visibles.vegetacion_matorral_desertico_rosetofilo = nv;
      // Pastizales
      this.visibles.vegetacion_pastizal_cultivado = nv;
      this.visibles.vegetacion_pastizal_inducido = nv;
      this.visibles.vegetacion_pastizal_halofilo = nv;
      // Otra
      this.visibles.vegetacion_bosque_cultivado = nv;
      this.visibles.vegetacion_halofila_hidrofila = nv;
      this.visibles.vegetacion_pradera_alta_montana = nv;
      this.visibles.vegetacion_tular = nv;
      this.visibles.vegetacion_sin_vegetacion_aparente = nv;
      this.visibles.vegetacion_desprovisto_vegetacion = nv;
    },
  },
  methods:{
    tooltip(f){
      return  `${f.descripcion}`
    }
  },
  beforeMount(){
    let nv = this.esteTemaActivo;
    // Bosque de encino
      this.visibles.vegetacion_bosque_encino = nv;
      this.visibles.vegetacion_bosque_encino_arborea = nv;
      this.visibles.vegetacion_bosque_encino_arbustiva = nv;
      this.visibles.vegetacion_bosque_encino_herbacea = nv;
      // Bosque de encino-pino
      this.visibles.vegetacion_bosque_encino_pino = nv;
      this.visibles.vegetacion_bosque_encino_pino_arbustiva = nv;
      // Bosque de oyamel
      this.visibles.vegetacion_bosque_oyamel = nv;
      this.visibles.vegetacion_bosque_oyamel_arbustiva = nv;
      // Bosque de pino
      this.visibles.vegetacion_bosque_pino = nv;
      this.visibles.vegetacion_bosque_pino_arborea = nv;
      this.visibles.vegetacion_bosque_pino_arbustiva = nv;
      // Bosque de pino-encino
      this.visibles.vegetacion_bosque_pino_encino = nv;
      this.visibles.vegetacion_bosque_pino_encino_arborea = nv;
      this.visibles.vegetacion_bosque_pino_encino_arbustiva = nv;
      // Bosque de táscate
      this.visibles.vegetacion_bosque_tascate = nv;
      this.visibles.vegetacion_bosque_tascate_arborea = nv;
      this.visibles.vegetacion_bosque_tascate_arbustiva = nv;
      // Matorrales
      this.visibles.vegetacion_matorral_crasicaule = nv;
      this.visibles.vegetacion_matorral_crasicaule_arbustiva = nv;
      this.visibles.vegetacion_matorral_desertico_rosetofilo = nv;
      // Pastizales
      this.visibles.vegetacion_pastizal_cultivado = nv;
      this.visibles.vegetacion_pastizal_inducido = nv;
      this.visibles.vegetacion_pastizal_halofilo = nv;
      // Otra
      this.visibles.vegetacion_bosque_cultivado = nv;
      this.visibles.vegetacion_halofila_hidrofila = nv;
      this.visibles.vegetacion_pradera_alta_montana = nv;
      this.visibles.vegetacion_tular = nv;
      this.visibles.vegetacion_sin_vegetacion_aparente = nv;
      this.visibles.vegetacion_desprovisto_vegetacion = nv;
  }
};
</script>